import type { MetricsTempFBMetricItem } from '../types';

export const CONTENT_METRICS_BANNER_TOGGLE_STATE_STORAGE_KEY = 'content_metrics_banner_toggle_state';
export const COMMON_THUMBNAIL_DIMENSION = 64;

export const THUMBNAIL_SIZES = {
  post: { width: COMMON_THUMBNAIL_DIMENSION, height: COMMON_THUMBNAIL_DIMENSION },
  regram_post: { width: COMMON_THUMBNAIL_DIMENSION, height: COMMON_THUMBNAIL_DIMENSION },
  story: { width: COMMON_THUMBNAIL_DIMENSION, height: 113 },
  regram_story: { width: COMMON_THUMBNAIL_DIMENSION, height: 113 },
  reel: { width: COMMON_THUMBNAIL_DIMENSION, height: 113 }
};

export const EMPTY_POST: MetricsTempFBMetricItem = {
  code: '',
  imageUrl: '',
  impressions: 0,
  interactions: 0,
  reach: 0,
  saves: 0,
  selected: false,
  videoUrl: '',
  videoViews: 0
};

export const EMPTY_STORY: MetricsTempFBMetricItem = {
  code: '',
  exits: 0,
  hashtags: [],
  imageUrl: '',
  impressions: 0,
  mentions: [],
  reach: 0,
  replies: 0,
  selected: false,
  storyType: 'image',
  takenAt: '',
  tapsBack: 0,
  tapsForward: 0,
  videoUrl: ''
};

export const EMPTY_REEL: MetricsTempFBMetricItem = {
  code: '',
  comments: 0,
  imageUrl: '',
  likes: 0,
  reach: 0,
  saves: 0,
  selected: false,
  shares: 0,
  interactions: 0,
  videoUrl: ''
};
